/* this file is transformed by vux-loader */
/* eslint-disable */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import ImgItem from '@/components/ImgItem';
import GoodsItem from './GoodsItem';
export default {
  props: {
    itemArr: {
      type: Array
    },
    isHot: {
      type: Boolean,
      "default": false
    },
    title: {
      type: String
    },
    id: String
  },
  components: {
    ImgItem: ImgItem,
    GoodsItem: GoodsItem
  },
  computed: {},
  data: function data() {
    return {};
  },
  created: function created() {},
  methods: {
    goCategory: function goCategory(id, title) {
      this.$emit('goCategory', id, title);
    }
  }
};